import { render, staticRenderFns } from "./SupplierTypeCreateEdit.vue?vue&type=template&id=560c4c34&scoped=true&"
import script from "./SupplierTypeCreateEdit.vue?vue&type=script&lang=js&"
export * from "./SupplierTypeCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./SupplierTypeCreateEdit.vue?vue&type=style&index=0&id=560c4c34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560c4c34",
  null
  
)

export default component.exports